import axios from "axios";
import Cookies from "js-cookie";
import { showWindowMessage } from "@utils/notification";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 20000,
  transformRequest: [
    function(data) {
      let ret = "";
      for (const it in data) {
        ret +=
          encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
      }
      return ret;
    }
  ],
  // 设置请求头 || 设置
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
});

service.interceptors.request.use(
  config => {
    const token = Cookies.get("token");
    if (token) {
      // 自定义请求头
      config.headers["token"] = token;
    }
    return config;
  },
  error => {
    console.log(error); // for debug    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    console.log("err" + error.message); // for debug
    if (error.response.status === 403) {
      showWindowMessage(1, "登录已过期, 请重新登录", this);
      sessionStorage.clear();
      this.$route.push({
        path: "/login"
      });
    }
    return Promise.reject(error);
  }
);
export default service;
